import { create } from "zustand";
import type { AppUser } from "@/lib/types";

interface AuthState {
  user: AppUser | null;
  uid: string | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  setUser: (uid: string | null, user: AppUser | null) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  uid: null,
  isLoading: true,
  isAuthenticated: false,
  setUser: (uid, user) =>
    set({ uid, user, isAuthenticated: Boolean(uid && user), isLoading: false }),
  setLoading: (isLoading) => set({ isLoading }),
  reset: () => set({ user: null, uid: null, isAuthenticated: false, isLoading: false }),
}));
